import { render, staticRenderFns } from "./SelfJugeList.vue?vue&type=template&id=4e74f444&scoped=true&"
import script from "./SelfJugeList.vue?vue&type=script&lang=js&"
export * from "./SelfJugeList.vue?vue&type=script&lang=js&"
import style0 from "./SelfJugeList.vue?vue&type=style&index=0&id=4e74f444&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e74f444",
  null
  
)

export default component.exports